import Chart from "chart.js";

const sharedOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    yAxes: [
      {
        gridLines: { drawBorder: false, color: "rgba(0, 0, 0, 0.05)" },
        ticks: {
          beginAtZero: true,
          fontColor: "#858585",
          padding: 10,
          precision: 0,
        },
      },
    ],
    xAxes: [
      {
        gridLines: { display: false },
        ticks: { fontColor: "#858585", fontStyle: "600" },
      },
    ],
  },
  legend: { display: false },
  tooltips: {
    backgroundColor: "#FFF",
    titleFontColor: "#373333",
    bodyFontColor: "#858585",
    borderColor: "#D1D3D4",
    borderWidth: 1,
    cornerRadius: 4,
    displayColors: true,
  },
};

const statusColorsMap = {
  SON: "rgba(40, 167, 69, 0.8)",
  SOFL: "rgba(255, 193, 7, 0.8)",
  SOFM: "rgba(253, 126, 20, 0.8)",
  SOFG: "rgba(167, 29, 42, 0.8)",
  SOP: "rgba(0, 123, 255, 0.8)",
  SI: "rgba(220, 53, 69, 0.8)",
};

const paletteColors = [
  "rgba(0, 44, 95, 0.7)",
  "rgba(60, 145, 219, 0.7)",
  "rgba(75, 192, 192, 0.7)",
  "rgba(255, 99, 132, 0.7)",
  "rgba(255, 206, 86, 0.7)",
  "rgba(153, 102, 255, 0.7)",
  "rgba(201, 203, 207, 0.7)",
];
const paletteBorders = [
  "#002C5F",
  "#3C91DB",
  "#4BC0C0",
  "#FF6384",
  "#FFCE56",
  "#9966FF",
  "#C9CBCE",
];

// Traduções para o PDF
const statusTranslationMap = {
  SON: "Sistema operando normalmente",
  SOFL: "Sistema operando com falha leve",
  SOFM: "Sistema operando com falha média",
  SOFG: "Sistema operando com falha grave",
  SOP: "Sistema operando parcialmente",
  SI: "Sistema inoperante",
};

// --- RENDERIZADORES ---

function renderReportsChart(labels = null, dataValues = null) {
  const ctx = document.getElementById("reportsChart");
  if (!ctx) return;

  // Se não vier dados novos, tenta ler do HTML (carga inicial)
  if (!labels || !dataValues) {
    if (!ctx.dataset.labels) return;
    labels = JSON.parse(ctx.dataset.labels);
    dataValues = JSON.parse(ctx.dataset.values);
  }

  if (window.myReportsChart) window.myReportsChart.destroy();
  window.myReportsChart = new Chart(ctx, {
    type: "bar",
    data: {
      labels: labels,
      datasets: [
        {
          label: "Relatórios",
          data: dataValues,
          backgroundColor: paletteColors.slice(0, labels.length),
          borderColor: paletteBorders.slice(0, labels.length),
          borderWidth: 1.5,
          barPercentage: 0.4,
          maxBarThickness: 50,
        },
      ],
    },
    options: sharedOptions,
  });
}

function renderStatusChart(labels = null, dataValues = null) {
  const ctx = document.getElementById("statusChart");
  if (!ctx) return;

  if (!labels || !dataValues) {
    if (!ctx.dataset.labels) return;
    labels = JSON.parse(ctx.dataset.labels);
    dataValues = JSON.parse(ctx.dataset.values);
  }

  const bgColors = labels.map(
    (label) => statusColorsMap[label] || "rgba(201, 203, 207, 0.7)",
  );
  const borderColors = bgColors.map((color) => color.replace("0.8", "1.0"));

  if (window.myStatusChart) window.myStatusChart.destroy();
  window.myStatusChart = new Chart(ctx, {
    type: "bar",
    data: {
      labels: labels,
      datasets: [
        {
          label: "Sistemas",
          data: dataValues,
          backgroundColor: bgColors,
          borderColor: borderColors,
          borderWidth: 1.5,
          barPercentage: 0.4,
          maxBarThickness: 50,
        },
      ],
    },
    options: sharedOptions,
  });
}

// --- HELPERS ---
function getFilterParams(url) {
  const customerId = document.getElementById("filter_customer")?.value;
  const serviceType = document.getElementById("filter_service")?.value;
  const year = document.getElementById("filter_year")?.value;
  const month = document.getElementById("filter_month")?.value;
  const status = document.getElementById("filter_status")?.value;

  if (customerId) url.searchParams.append("customer_id", customerId);
  if (serviceType) url.searchParams.append("service_type", serviceType);
  if (year) url.searchParams.append("year", year);
  if (month) url.searchParams.append("month", month);
  if (status) url.searchParams.append("report_status", status);

  return { customerId };
}

// --- ATUALIZAÇÃO AUTOMÁTICA DOS DOIS GRÁFICOS ---
async function fetchAndUpdateCharts() {
  try {
    // 1. Atualiza Status
    const urlStatus = new URL(
      window.location.origin + "/dashboard/system_status",
    );
    getFilterParams(urlStatus);
    const respStatus = await fetch(urlStatus);
    const dataStatus = await respStatus.json();
    renderStatusChart(
      Object.keys(dataStatus.status_counts),
      Object.values(dataStatus.status_counts),
    );

    // 2. Atualiza Visão Geral (NOVO)
    const urlReports = new URL(
      window.location.origin + "/dashboard/reports_by_type",
    );
    getFilterParams(urlReports);
    const respReports = await fetch(urlReports);
    const dataReports = await respReports.json();
    renderReportsChart(dataReports.labels, dataReports.values);
  } catch (error) {
    console.error("Erro ao atualizar gráficos:", error);
  }
}

async function exportPDF(e) {
  e.preventDefault();
  const btn = document.getElementById("btn-export-pdf");
  const originalText = btn.innerHTML;
  btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Gerando...';
  btn.disabled = true;

  try {
    const url = new URL(
      window.location.origin + "/dashboard/detailed_report_data",
    );
    getFilterParams(url); // Aplica os mesmos filtros da tela

    const response = await fetch(url);
    const result = await response.json();
    const records = result.data;

    if (!records || records.length === 0) {
      alert("Nenhum dado encontrado com esses filtros.");
      btn.innerHTML = originalText;
      btn.disabled = false;
      return;
    }

    const printWindow = window.open("", "", "height=600,width=800");

    // Tenta pegar o nome do cliente selecionado para o título
    const selectCust = document.getElementById("filter_customer");
    let customerName = "Geral";
    if (
      selectCust &&
      selectCust.selectedIndex >= 0 &&
      selectCust.options[selectCust.selectedIndex]
    ) {
      customerName = selectCust.options[selectCust.selectedIndex].text;
    }

    const htmlContent = `
      <html>
        <head>
          <title>Relatório - Omini</title>
          <style>
            body { font-family: Arial, sans-serif; font-size: 12px; color: #333; padding: 20px; }
            h1 { color: #003A70; border-bottom: 2px solid #003A70; padding-bottom: 10px; }
            .meta { margin-bottom: 20px; color: #666; font-size: 14px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th { background-color: #f2f2f2; text-align: left; padding: 8px; border: 1px solid #ddd; font-weight: bold; }
            td { padding: 8px; border: 1px solid #ddd; }
            tr:nth-child(even) { background-color: #f9f9f9; }
          </style>
        </head>
        <body>
          <h1>Relatório de Status</h1>
          <div class="meta">
            <strong>Cliente:</strong> ${customerName}<br>
            <strong>Data de Geração:</strong> ${new Date().toLocaleDateString()}<br>
            <strong>Total de Registros:</strong> ${result.total_records}
          </div>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Localidade</th>
                <th>Cliente</th>
                <th>Tipo de sistemas</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              ${records
                .map((r) => {
                  // Tradução da Sigla
                  const fullStatus =
                    statusTranslationMap[r.classification] || r.classification;
                  // Cor da Sigla
                  const color = statusColorsMap[r.classification] || "#333";

                  return `
                <tr>
                  <td>${r.system_id}</td>
                  <td>${r.system_name}</td>
                  <td>${r.customer_name}</td>
                  <td>${r.service_type}</td>
                  <td style="color: ${color}; font-weight: bold;">${fullStatus}</td>
                </tr>
              `;
                })
                .join("")}
            </tbody>
          </table>
          <script>window.onload = function() { window.print(); }</script>
        </body>
      </html>
    `;
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  } catch (error) {
    console.error("Erro PDF:", error);
    alert("Erro ao processar PDF.");
  } finally {
    btn.innerHTML = originalText;
    btn.disabled = false;
  }
}

function initFilters() {
  if (!isDashboardPage()) return;

  const ids = [
    "filter_customer",
    "filter_service",
    "filter_year",
    "filter_month",
    "filter_status",
  ];
  ids.forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;

    // Evita handlers duplicados com Turbolinks.
    el.removeEventListener("change", fetchAndUpdateCharts);
    el.addEventListener("change", fetchAndUpdateCharts);
  });
}

function isDashboardPage() {
  // O dashboard sempre tem o grafico de status.
  return !!document.getElementById("statusChart");
}

function hasReportsChart() {
  return !!document.getElementById("reportsChart");
}

function initAll() {
  // O grafico "Visao Geral" existe tanto no dashboard quanto em "Relatorios Pendentes".
  if (hasReportsChart()) {
    renderReportsChart();
  }

  // Somente o dashboard tem filtros dinamicos e grafico de status.
  if (!isDashboardPage()) return;

  renderStatusChart();
  initFilters();

  const btnPdf = document.getElementById("btn-export-pdf");
  if (btnPdf) btnPdf.addEventListener("click", exportPDF);

  fetchAndUpdateCharts();
}

document.addEventListener("turbolinks:load", initAll);
document.addEventListener("DOMContentLoaded", initAll);
